import { commonService } from '../../_services'
const service = commonService('api/v1/calendars')

const initialState = {
  all: { items: [] },
  loading: false,
}

const deepCloneInitial = JSON.parse(JSON.stringify(initialState))

/* tslint:disable:variable-name */
export const calendars = {
  namespaced: true,
  state: deepCloneInitial,
  actions: {
    async getAll(context: any, params: any = {}): Promise<void> {
      context.commit('GET_ALL_REQUEST')

      return service.getAll(params).then((resp) => {
        context.commit('GET_ALL_SUCCESS', resp.data)
      }).catch(errorMsg => {
        context.commit('GET_ALL_FAILURE')
        context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
      })
    },
  },
  mutations: {
    GET_ALL_REQUEST(state: any) {
      state.loading = true
    },
    GET_ALL_SUCCESS(state: any, allItems: any[]) {
      state.all = { items: allItems.map(item => item) }
      state.loading = false
    },
    GET_ALL_FAILURE(state: any) {
      state.all = { items: [] }
      state.loading = false
    },
    RESET_STATE(state: any) {
      const init = JSON.parse(JSON.stringify(initialState))
      Object.keys(init).forEach(key => {
        state[key] = init[key]
      })
    },
  },
  getters: {},
}
